import { render, staticRenderFns } from "./AdminEduTypeAdd.vue?vue&type=template&id=1b6962d8"
import script from "./AdminEduTypeAdd.vue?vue&type=script&lang=js"
export * from "./AdminEduTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports